// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2cYxU","noInteraction":"EventWrapper_noInteraction__1MTND","pointerPassthrough":"EventWrapper_pointerPassthrough__3Z2Rw"};